import { useEffect } from 'react';
import { Outlet, useMatches } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useScrollToTop } from '@/hooks/useScrollToTop';

export function createRootLayout(baseTitle: string) {
  function RootComponent() {
    useScrollToTop();
    const matches = useMatches();

    useEffect(() => {
      const last = matches[matches.length - 1];
      type MatchWithStaticData = { staticData?: { title?: string } };
      const title = (last as MatchWithStaticData | undefined)?.staticData?.title;
      document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    }, [matches]);

    return (
      <>
        <Outlet />
        {import.meta.env.DEV && <TanStackRouterDevtools />}
      </>
    );
  }

  function PendingComponent() {
    return null;
  }

  return { RootComponent, PendingComponent };
}
